// extracted by mini-css-extract-plugin
module.exports = {"label":"L_cd","text":"L_cz"};